import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { CurrencyIcon } from '@root/entities/currency/ui'

import { PremiumListItemInformation } from './premium-list-item-information'

import type { CurrencyModel } from '@root/entities/currency'
import type { PremiumMetaModel } from '@root/entities/premium'
type Props = {
  currency: CurrencyModel
  premiumMeta: PremiumMetaModel
  premiumInfo: React.ReactNode
  actions: React.ReactNode
  onClick?: (currency: CurrencyModel) => void
}

export const PremiumListItem: React.FC<Props> = ({
  currency,
  premiumMeta,
  premiumInfo,
  actions,
  onClick,
}) => {
  const [premium] = useAtom(premiumMeta.premium)
  return (
    <PremiumListItemRoot onClick={() => onClick?.(currency)}>
      <CurrencyInfo>
        <CurrencyIcon
          outline={premium ? 'premium' : 'outline'}
          currency={currency}
          size={premium ? 32 : 26}
          withNetwork
        />
        <PremiumListItemInformation currency={currency} premium={premiumMeta} />
      </CurrencyInfo>
      <PremiumInfo>{premiumInfo}</PremiumInfo>
      <Action>{actions}</Action>
    </PremiumListItemRoot>
  )
}

export const PremiumListItemRoot = styled.div`
  background: var(--background-2);

  border-radius: 12px;
  height: 60px;

  padding-block: 9px;

  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
`

const CurrencyInfo = styled.div`
  display: grid;
  align-items: center;
  min-width: 0;
  overflow: hidden;

  grid-template-columns: auto 1fr;
  gap: 8px;

  padding-inline: 15px;
`

const PremiumInfo = styled.div`
  background: var(--appearanceA-2);
  border-radius: 10px;

  height: 44px;
  display: grid;
  grid-auto-flow: column;

  align-items: center;
  padding-inline: 16px;
`

const Action = styled.div`
  display: grid;
  align-items: center;
  grid-auto-flow: column;
  justify-content: end;

  gap: 6px;
  padding-inline: 14px;
`
